import React from 'react';
import Anchor from '@sdtech/sd-ui/Anchor';

const errorMessages = {
  'SPDF-1':
  <div>
    Sorry, but we are unable to provide you with access to this content. Please contact our
    {' '}
    <Anchor href="https://service.elsevier.com/app/contact/supporthub/sciencedirect/" className="u-clr-orange"> support team</Anchor>
    {' '}
    for further information.
  </div>,
  'SPDF-2': <div>Sorry, but we are unable to provide you with access to this content. Please contact your librarians or administrators.</div>,
  default: <div>Sorry, but we are unable to provide you with access to this content.</div>,
};

const ErrorFragment = ({ errorCode }) => {
  const ErrorMessage = errorCode in errorMessages
    ? errorMessages[errorCode]
    : errorMessages.default;
  return (
    ErrorMessage
  );
};

export default ErrorFragment;
